import { useState, useRef, useEffect } from 'react';
import './FacilityFilter.css';

function FacilityFilter({ selectedIds, onChange, facilities = [] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggle = (id) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((fid) => fid !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  const selectAll = () => onChange(facilities.map((f) => f.id));
  const clearAll = () => onChange([]);

  const label =
    selectedIds.length === 0 || selectedIds.length === facilities.length
      ? 'All Facilities'
      : selectedIds.length === 1
        ? facilities.find((f) => f.id === selectedIds[0])?.name || '1 facility'
        : `${selectedIds.length} facilities`;

  return (
    <div className="facility-filter" ref={ref}>
      <button
        className={`facility-filter-trigger ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
        <span className="filter-label">{label}</span>
        <svg className={`filter-chevron ${open ? 'open' : ''}`} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="facility-filter-dropdown">
          <div className="filter-dropdown-actions">
            <button onClick={selectAll} className="filter-action-btn">Select All</button>
            <button onClick={clearAll} className="filter-action-btn">Clear All</button>
          </div>
          <div className="filter-dropdown-list">
            {facilities.map((facility) => (
              <label key={facility.id} className="filter-option">
                <input
                  type="checkbox"
                  checked={selectedIds.length === 0 || selectedIds.includes(facility.id)}
                  onChange={() => toggle(facility.id)}
                />
                <span className="filter-checkbox">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
                <span className="filter-option-text">
                  <span className="filter-option-name">{facility.name}</span>
                  <span className="filter-option-location">{facility.city}, {facility.state}</span>
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default FacilityFilter;
